/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import ShowByDialog from '../../components/showBy/ShowByDialog';
import React from 'react';
import ReactDOM from 'react-dom';

const View = require('gemini/lib/@waca/core-client/js/core-client/ui/core/View');

/**
* The actual dialog controller which handles selection and changes from the react components.
*/
const ShowByView = View.extend({
	/**
	 * Initialize a new dialog
	 * @param options - an object of the following form
	 *		{
	 *			eventHandler - action handler when user selects a column in the showByDialog
	*			contextColumns - all category columns in the data set
	*			getRecommendedColumns - callback to get possible key drivers of category type of projected items in the widget
	*		}
	*/
	init: function(options) {
		ShowByView.inherited('init', this, arguments);
		this.dialogOptions = {
			eventHandler: options.eventHandler,
			contextColumns: options.contextColumns,
			shapingHelper: options.shapingHelper,
			getRecommendedColumns: options.getRecommendedColumns
		};
		this.selectionHandler = this.selectionHandler.bind(this);
	},

	render: function() {
		return this._renderReactComponents(this.dialogOptions).then(() => {
			return this;
		});
	},

	_renderReactComponents: function(options) {
		this.$el.addClass('popoverDialogContainer');
		return options.getRecommendedColumns().then((recommendedColumns) => {
			options.recommendedColumns = recommendedColumns;
			// Render the react components
			ReactDOM.render(
				<ShowByDialog
					contextColumns={options.contextColumns}
					eventHandler={this.selectionHandler}
					recommendedColumns={options.recommendedColumns}
					shapingHelper={options.shapingHelper}
				/>,
				this.$el[0]
			);
		});
	},

	selectionHandler(value) {
		if (this.dialogOptions.eventHandler) {
			this.remove();
			this.dialogOptions.eventHandler({
				context: {
					id: value.id,
					label: value.label
				}
			});
		}
	},

	/**
	* Remove the dialog and toolbar.
	*/
	remove: function() {
		ReactDOM.unmountComponentAtNode(this.$el[0]);
		// If there is a toolbar and a flyout, close it.
		if(this.toolbar && this.toolbar.flyout){
			this.toolbar.flyout.close();
		}
		ShowByView.inherited('remove', this);
	},

	/**
	* @param  {Object} toolbar that the dialog is being rendered from.
	*/
	renderCallBack: function(toolbar) {
		this.toolbar = toolbar;
		return Promise.resolve();
	},

	/**
	* Needed so toolbar is set in NextView and the flyout can be closed when remove the dialog
	*/
	preload() {return Promise.resolve();}
});

export default ShowByView;



// WEBPACK FOOTER //
// ./src/js/features/showByCompareBy/ShowByView.js